/**
 * Outside counsel guidelines on show in the Compliance > OCGs tab.
 *
 * Demo fixture. The PDFs in `public/ocgs/` are the real documents these clients
 * publish; the metadata below is transcribed from them. No rules live here --
 * each guideline names a client and the tab counts that client's real
 * billing rules, so the two tabs cannot drift apart.
 *
 * `clientCode` matches `billing_guidelines.client_code`, which in this tenant
 * holds the client *name* rather than a code. It must match `matters_tm.client`
 * exactly or the guideline will report zero rules.
 */
export type OcgDocument = {
	id: string;
	/** Value of billing_guidelines.client_code -- the client name in this tenant. */
	clientCode: string;
	/** Document title as the client publishes it. */
	title: string;
	/** Served from public/ocgs/. */
	file: string;
	/** First page rendered at build time; served from public/ocgs/thumbs/. */
	thumb: string;
	pages: number;
	/** Effective or revision date printed on the document itself. */
	effective: string;
	/** ISO date the document was "uploaded", for the Added column. */
	addedAt: string;
};

export const OCG_DOCUMENTS: OcgDocument[] = [
	{
		id: "state-farm-2025",
		clientCode: "State Farm Insurance",
		title:
			"State Farm Law Department Billing Guidelines — Corporate Law Division",
		file: "/ocgs/state-farm-billing-guidelines-2025.pdf",
		thumb: "/ocgs/thumbs/state-farm-billing-guidelines-2025.webp",
		pages: 14,
		effective: "Effective 1 Sep 2025",
		addedAt: "2026-09-02",
	},
	{
		id: "amfam-2024",
		clientCode: "American Family Insurance",
		title: "Panel Counsel Litigation and Billing Guidelines",
		file: "/ocgs/amfam-panel-counsel-guidelines-2024.pdf",
		thumb: "/ocgs/thumbs/amfam-panel-counsel-guidelines-2024.webp",
		pages: 15,
		effective: "Revised Jun 2024",
		addedAt: "2026-09-02",
	},
	{
		id: "fwci-2023",
		clientCode: "Frank Winston Crum Insurance",
		title: "FWCI Litigation Standards for Panel Counsel",
		file: "/ocgs/fwci-litigation-standards-2023.pdf",
		thumb: "/ocgs/thumbs/fwci-litigation-standards-2023.webp",
		pages: 13,
		effective: "Updated 9 Jun 2023",
		addedAt: "2026-09-03",
	},
	{
		id: "fcci-2024",
		clientCode: "FCCI Insurance Group",
		title: "FCCI Litigation Guidelines",
		file: "/ocgs/fcci-litigation-guidelines-2024.pdf",
		thumb: "/ocgs/thumbs/fcci-litigation-guidelines-2024.webp",
		pages: 10,
		effective: "Effective 8 Jan 2024",
		addedAt: "2026-09-03",
	},
	{
		id: "cvs-health",
		clientCode: "CVS Health",
		title: "CVS Health Outside Counsel Guidelines",
		file: "/ocgs/cvs-health-outside-counsel-guidelines.pdf",
		thumb: "/ocgs/thumbs/cvs-health-outside-counsel-guidelines.webp",
		pages: 50,
		effective: "Current revision",
		addedAt: "2026-09-04",
	},
];
